import { Suspense, useRef } from 'react'
import Spinner from '../spinner/spinner'
import { Outlet } from 'react-router-dom'
import useRouteChange from '@/presentation/hooks/navigate/use-route-change'
import { SCROLL_TOP_PARAMS } from '@/presentation/helpers/page/url-helper'

function RootLayout() {
  const prevPathnameRef = useRef<string | null>(null)

  useRouteChange(pathname => {
    if (prevPathnameRef.current !== pathname) {
      prevPathnameRef.current = pathname
      setTimeout(() => window.scrollTo(SCROLL_TOP_PARAMS), 0)
    }
  })

  return (
    <Suspense fallback={<Spinner fullScreen />}>
      <Outlet />
    </Suspense>
  )
}

export default RootLayout
